import React from 'react'
import { Link } from 'react-router-dom'
import { FiEdit2, FiTrash2, FiRefreshCw } from 'react-icons/fi'

export default function BranchActionIcons({ branch, onDelete, onRestore, editPath }) {
  if (!branch.isDeleted) {
    return (
      <>
        <Link
          to={(editPath || '/branch-update/') + branch._id}
          className='branch-btn-icon branch-action-icon branch-action-icon-edit'
          title='Edit'
        >
          <FiEdit2 />
        </Link>
        <button
          className='branch-btn-icon branch-action-icon branch-action-icon-delete'
          title='Delete'
          onClick={() => onDelete(branch._id)}
        >
          <FiTrash2 />
        </button>
      </>
    )
  }

  return (
    <button
      className='branch-btn-icon branch-action-icon branch-action-icon-restore'
      title='Restore'
      onClick={() => onRestore(branch._id)}
    >
      <FiRefreshCw />
    </button>
  )
}
